import {
  Actions as SentinelActions,
  getSentinelById,
} from '../actions/sentinels';
import { Routes } from '../routes';
import history from '../history';

const sentinelMiddleware = store => next => action => {
  switch (action.type) {
    case SentinelActions.UPDATE_SENTINEL_SUCCESS:
      store.dispatch(getSentinelById(action.data.id));
      history.push(Routes.SENTINELS, {
        successAlert: 'Sentinel updated successfully!',
      });
      return next(action);

    case SentinelActions.CREATE_SENTINEL_SUCCESS:
      store.dispatch(getSentinelById(action.data.id));
      history.push(Routes.SENTINELS, {
        successAlert: 'Sentinel created successfully!',
      });
      return next(action);

    case SentinelActions.UPDATE_SENTINEL_ERROR:
      return next(action);

    case SentinelActions.CREATE_SENTINEL_ERROR:
      return next(action);

    default:
      return next(action);
  }
};

export default sentinelMiddleware;
